import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth/auth';
import { ProfileService } from '../../services/profile/profile';

@Component({
  selector: 'app-profile',
  standalone: false,
  templateUrl: './profile.html',
  styleUrls: ['./profile.css']
})
export class Profile {
  currentPassword = '';
  newPassword = '';
  confirmPassword = '';

  changingPassword = false;

  constructor(
    private authService: AuthService,
    private profileService: ProfileService,
    private toastr: ToastrService
  ) {}

  get adminName(): string {
    return this.authService.getAdminName();
  }

  get adminEmail(): string {
    return this.authService.getAdminEmail();
  }

  get adminRole(): string {
    const role = this.authService.getAdminRole();

    switch (role) {
      case 1:
        return 'SuperAdmin';
      case 2:
        return 'Admin';
      case 3:
        return 'Support';
      default:
        return 'Unknown';
    }
  }

  changePassword(): void {
    if (!this.currentPassword.trim()) {
      this.toastr.warning('Current password is required.', 'Validation');
      return;
    }

    if (!this.newPassword.trim()) {
      this.toastr.warning('New password is required.', 'Validation');
      return;
    }

    if (this.newPassword !== this.confirmPassword) {
      this.toastr.warning('Passwords do not match.', 'Validation');
      return;
    }

    this.changingPassword = true;

    this.profileService.changePassword({
      currentPassword: this.currentPassword,
      newPassword: this.newPassword
    }).subscribe({
      next: response => {
        this.changingPassword = false;

        if (!response.success) {
          this.toastr.error(response.message || 'Unable to change password.');
          return;
        }

        this.toastr.success('Password changed successfully.');

        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
      },
      error: error => {
        this.changingPassword = false;

        this.toastr.error(
          error?.error?.message ||
            error?.error?.error?.details ||
            'Unable to change password.',
          'Profile'
        );
      }
    });
  }
}